// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_invitation_model from "./web_invitation_model.js";
import * as Mapre_web__Web_members_view from "./web_members_view.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function action(send, value) {
  const partial_arg = {
    TAG: /* Invitations */ 48,
    _0: value
  };
  return function (param) {
    return Lui_elements.press(send, partial_arg, param);
  };
}

function form(model) {
  return Stdlib__Option.value(model.invitation_form, Mapre_web__Web_invitation_model.initial(/* Manage */ 0, ""));
}

function roles(source, send) {
  const partial_arg = Stdlib__List.map((function (param) {
    const value = param[1];
    const label = param[0];
    return function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___004_) {
        const partial_arg = {
          TAG: /* Invitations */ 48,
          _0: {
            TAG: /* Role */ 3,
            _0: value
          }
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
          const f = form(m);
          if (f.pending) {
            return true;
          } else {
            return f.uncertain;
          }
        }), source)));
        const partial_arg$3 = "outline";
        const partial_arg$4 = label;
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    };
  }), {
    hd: [
      "Viewer",
      "viewer"
    ],
    tl: {
      hd: [
        "Member",
        "member"
      ],
      tl: {
        hd: [
          "Admin",
          "admin"
        ],
        tl: /* [] */ 0
      }
    }
  });
  const partial_arg$1 = 8;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
}

function view(source, send) {
  const partial_arg = Signal.map((function (m) {
    return form(m).mode;
  }), source);
  const partial_arg$1 = {
    TAG: /* Invitations */ 48,
    _0: /* Refresh */ 3
  };
  const partial_arg$2 = (function (param) {
    return Lui_elements.press(send, partial_arg$1, param);
  });
  const partial_arg$3 = "ghost";
  const partial_arg$4 = "Refresh invitations";
  const partial_arg$5 = {
    TAG: /* Invitations */ 48,
    _0: /* Close */ 0
  };
  const partial_arg$6 = (function (param) {
    return Lui_elements.press(send, partial_arg$5, param);
  });
  const partial_arg$7 = "ghost";
  const partial_arg$8 = "Close invitations";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$9 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$10 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.dyn(undefined, (function (param) {
      if (/* tag */ typeof param !== "object" && typeof param !== "function") {
        const partial_arg = "Invite members by email";
        const partial_arg$1 = 2;
        const partial_arg$2 = "The invited email must be verified on the recipient's GitHub account. Invitations expire after seven days.";
        const partial_arg$3 = "muted";
        const partial_arg$4 = Signal.map((function (m) {
          return form(m).rows;
        }), source);
        const partial_arg$5 = {
          TAG: /* Invitations */ 48,
          _0: /* More */ 4
        };
        const partial_arg$6 = (function (param) {
          return Lui_elements.press(send, partial_arg$5, param);
        });
        const partial_arg$7 = "ghost";
        const partial_arg$8 = "More invitations";
        const partial_arg$9 = function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
        const partial_arg$10 = Signal.map((function (m) {
          return form(m).cursor !== undefined;
        }), source);
        const partial_arg_0 = Mapre_web__Web_members_view.view(source, send);
        const partial_arg_1 = {
          hd: (function (param, param$1) {
            return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___005_) {
                const partial_arg = (function (param) {
                  return Lui_elements.on_input(send, (function (email) {
                    return {
                      TAG: /* Invitations */ 48,
                      _0: {
                        TAG: /* Email */ 2,
                        _0: email
                      }
                    };
                  }), param);
                });
                const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
                  const f = form(m);
                  if (f.pending) {
                    return true;
                  } else {
                    return f.uncertain;
                  }
                }), source)));
                const partial_arg$2 = "Email address";
                const partial_arg$3 = "person@example.com";
                const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
                  return form(m).email;
                }), source)));
                return function (param, param$1) {
                  return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }),
            tl: {
              hd: roles(source, send),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.scoped((function (__lui_context___006_) {
                    const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (m) {
                      return "Selected role: " + form(m).role;
                    }), source)));
                    return function (param, param$1) {
                      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param, param$1);
                }),
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  }),
                  tl: {
                    hd: (function (param, param$1) {
                      return Lui_elements.scoped((function (__lui_context___007_) {
                        const partial_arg = {
                          TAG: /* Invitations */ 48,
                          _0: /* Submit */ 1
                        };
                        const partial_arg$1 = (function (param) {
                          return Lui_elements.press(send, partial_arg, param);
                        });
                        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (m) {
                          return !(Mapre_web__Web_model.can_manage_members(m) && Mapre_web__Web_invitation_model.can_submit(form(m)));
                        }), source)));
                        const partial_arg$3 = "primary";
                        const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (m) {
                          const f = form(m);
                          if (f.pending) {
                            return "Sending invitation...";
                          } else if (f.uncertain) {
                            return "Retry invitation";
                          } else {
                            return "Send invitation";
                          }
                        }), source)));
                        return function (param, param$1) {
                          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                        };
                      }), param, param$1);
                    }),
                    tl: {
                      hd: (function (param, param$1) {
                        return Lui_elements.keyed(partial_arg$4, (function (i) {
                          return i.id;
                        }), Stdlib__String.compare, (function (param) {
                          const partial_arg = (function ($$event) {
                            const row = Signal.sample(param);
                            action(send, {
                              TAG: /* Revoke */ 4,
                              _0: row.id,
                              _1: row.version
                            })($$event);
                          });
                          const partial_arg$1 = "ghost";
                          const partial_arg$2 = "Revoke invitation";
                          const partial_arg$3 = function (param, param$1) {
                            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                          };
                          const partial_arg$4 = Signal.map((function (i) {
                            if (i.revoked) {
                              return false;
                            } else {
                              return !i.accepted;
                            }
                          }), param);
                          const partial_arg_0 = function (param$1, param$2) {
                            return Lui_elements.scoped((function (__lui_context___001_) {
                              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (i) {
                                return i.email + (" / " + i.role);
                              }), param)));
                              return function (param, param$1) {
                                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                              };
                            }), param$1, param$2);
                          };
                          const partial_arg_1 = {
                            hd: (function (param$1, param$2) {
                              return Lui_elements.scoped((function (__lui_context___002_) {
                                const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map(Mapre_web__Web_invitation_model.status, param)));
                                const partial_arg$1 = "muted";
                                return function (param, param$1) {
                                  return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                                };
                              }), param$1, param$2);
                            }),
                            tl: {
                              hd: (function (param$1, param$2) {
                                return Lui_elements.scoped((function (__lui_context___003_) {
                                  const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (i) {
                                    return Stdlib__Option.value(i.error, "");
                                  }), param)));
                                  const partial_arg$1 = "muted";
                                  return function (param, param$1) {
                                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                                  };
                                }), param$1, param$2);
                              }),
                              tl: {
                                hd: (function (param, param$1) {
                                  return Lui_elements.if_(partial_arg$4, partial_arg$3, param, param$1);
                                }),
                                tl: /* [] */ 0
                              }
                            }
                          };
                          const partial_arg$5 = {
                            hd: partial_arg_0,
                            tl: partial_arg_1
                          };
                          const partial_arg$6 = 8;
                          const partial_arg$7 = 4;
                          return function (param, param$1) {
                            return Lui_elements.column(undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
                          };
                        }), param, param$1);
                      }),
                      tl: {
                        hd: (function (param, param$1) {
                          return Lui_elements.if_(partial_arg$10, partial_arg$9, param, param$1);
                        }),
                        tl: /* [] */ 0
                      }
                    }
                  }
                }
              }
            }
          }
        };
        const partial_arg$11 = {
          hd: partial_arg_0,
          tl: partial_arg_1
        };
        const partial_arg$12 = 12;
        return function (param, param$1) {
          return Lui_elements.column(undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
        };
      } else {
        const partial_arg$13 = Signal.map((function (m) {
          return form(m).preview !== undefined;
        }), source);
        const partial_arg_0$1 = function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___008_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (m) {
              return Stdlib__Option.fold("Workspace invitation", (function (p) {
                return "Join " + p.name;
              }), form(m).preview);
            }), source)));
            const partial_arg$1 = 2;
            return function (param, param$1) {
              return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        };
        const partial_arg_1$1 = {
          hd: (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___009_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (m) {
                return Stdlib__Option.fold("", (function (p) {
                  return p.email + (" / " + p.role);
                }), form(m).preview);
              }), source)));
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$13, (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___010_) {
                  const partial_arg = {
                    TAG: /* Invitations */ 48,
                    _0: /* Accept */ 2
                  };
                  const partial_arg$1 = (function (param) {
                    return Lui_elements.press(send, partial_arg, param);
                  });
                  const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map((function (m) {
                    return form(m).pending;
                  }), source)));
                  const partial_arg$3 = "primary";
                  const partial_arg$4 = "Accept invitation";
                  return function (param, param$1) {
                    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }), param, param$1);
            }),
            tl: /* [] */ 0
          }
        };
        const partial_arg$14 = {
          hd: partial_arg_0$1,
          tl: partial_arg_1$1
        };
        const partial_arg$15 = 12;
        return function (param, param$1) {
          return Lui_elements.column(undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
        };
      }
    }), partial_arg, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___011_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___011_.ui_scope, Signal.map((function (m) {
          return form(m).message;
        }), source)));
        const partial_arg$1 = "notice";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.row(undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$11 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$12 = "form-card";
  const partial_arg$13 = 16;
  const partial_arg$14 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
